import { createFileRoute } from "@tanstack/react-router"
import z from "zod"
import { AuthVerifyPage } from "./-AuthVerifyPage"

const verifySearchSchema = z.object({
  email: z.string().optional(),
  token: z.string().optional(),
  callbackUrl: z.string().optional(),
  error: z.string().optional(),
})

export const Route = createFileRoute("/auth/verify")({
  validateSearch: verifySearchSchema,
  component: AuthVerifyPage,
})
